import script from "./addPCBuildComp.vue?vue&type=script&setup=true&lang=js"
export * from "./addPCBuildComp.vue?vue&type=script&setup=true&lang=js"

import "./addPCBuildComp.vue?vue&type=style&index=0&id=3261f596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3261f596"]])

export default __exports__